import { render, staticRenderFns } from "./FinGoriders.vue?vue&type=template&id=e5d20920&scoped=true&"
import script from "./FinGoriders.vue?vue&type=script&lang=js&"
export * from "./FinGoriders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d20920",
  null
  
)

export default component.exports